import React from "react";
import styled, { keyframes } from 'styled-components'
import tusdPng from '../../images/tusd-icon.png'

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`
const spin = keyframes`
to {
    transform: rotate(360deg);
}
`

const Spinner = styled.div`
animation: ${spin} 2s infinite linear;
border-radius: 50%;
width: 40px;
height: 40px;
border: 4px solid #185BFF;
border-top-color: ${(props) => props.topColor};
background-image: url(${props => props.bg});
background-repeat: no-repeat;
background-size: 20px 20px;
background-position: center;
`

const LoadingText = styled.p`
  font-size: 14px;
  margin-top: 10px;
`

function Loading(props) {
    return (
        <LoadingContainer>
            <Spinner topColor={props.spinTopColor} bg={tusdPng}>
            </Spinner>
            <LoadingText>{props.text}</LoadingText>
        </LoadingContainer>
    )
}

export { Loading }